// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"aab88d67","397":"05d28165","437":"bbd0cf8b","598":"da8d4429","626":"4ec7b698","650":"45e4ec36","714":"a44c3220"}[chunkId] + ".chunk.js";
};